import React, {useEffect, useRef, useState} from "react";
import {getClientWaiver, getRecentCompanyWaivers, previewClientWaiver} from "../../common/api/WebApi";
import {Card, Chip, FormControl, Select} from "@mui/material";
import MDBox from "../../../components/MDBox";
import {Link} from "react-router-dom";
import {formatDate, formatDateNoTz, formatDateTime} from "../../common/Utils";
import MDButton from "../../../components/MDButton";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import NotificationItem from "../../Items/NotificationItem";
import Preview from "../../common/modal/preview";
import MenuItem from "@mui/material/MenuItem";
import {getCookie, setCookie} from "../../common/appCookie";

export default function RecentWaiversPane({show, eventDate}) {

  const [waivers, setWaivers] = useState([]);

  useEffect(() => {
    getRecentCompanyWaivers(eventDate).then((resp) => {
      setWaivers(resp);
    });
  }, [eventDate]);

  const [renderIndex, setRenderIndex] = useState(1);
  const [waiverPreview, setWaiverPreview] = useState();
  const [showPreview, setShowPreview] = useState(false);
  const myRefs = useRef([]);

  const refHandler = (index) => {
    myRefs.current[index].visible = !!!myRefs.current[index].visible;
    setRenderIndex(renderIndex + 1);
  };

  const viewWaiver = async (client, item) => {
    previewClientWaiver(client, item.guid).then((result) => {
      setWaiverPreview(result);
      setShowPreview(true);
    });
  }

  const [sortInventory, setSortInventory] = useState({field: 'waiverDate', direction: 'asc'});

  useEffect(()=> {
    let _sort = getCookie('DASHBOARD_RECENT_WAIVERS');
    if (!_sort) {
      return;
    }
    let sorts = JSON.parse(_sort);
    let _sorts = {
      field: sorts['field'],
      direction: sorts['direction']
    };
    setSortInventory(_sorts)
  }, []);

  useEffect(()=> {
    setCookie('DASHBOARD_RECENT_WAIVERS', JSON.stringify(sortInventory));
  }, [sortInventory]);

  const sortInventoryFn = (a, b) => {
    const sortDir = sortInventory.direction === 'asc' ? 1 : -1;

    if (sortInventory.field === 'name') {
      return (
        a.createUser.lastName.localeCompare(
          b.createUser.lastName,
          undefined,
          {sensitivity: 'base'}
        ) * sortDir
      );
    }

    if (sortInventory.field === 'waiverDate') {
      const dateDiff =
        new Date(a.waiverDate).getTime() -
        new Date(b.waiverDate).getTime();

      return dateDiff !== 0
        ? dateDiff * sortDir
        : a.id - b.id;
    }

    return (a.id - b.id) * sortDir;
  };

  const downloadWaiver = async (client, item) => {
    getClientWaiver(client, item.guid).then((result) => {
      let blob = new Blob([result], {type: 'application/pdf'});
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, item.waiverName + '.pdf');
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", item.waiverName + '.pdf');
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    });
  }

  return (
    <>
      <Card>
        <MDBox p={3}>
          <h5>
            Recent Waivers
            {waivers?.length > 0 &&
              <span className={'d-block mb-2 pull-right'}>
              <span className={'d-inline p-1'} style={{
                fontSize: '14px'
              }}>Sort:</span>
              <FormControl sx={{
                width: 'auto'
              }}>
                <Select
                  autoWidth
                  sx={{
                    padding: '5px 10px',
                    marginRight: '5px'
                  }}
                  value={sortInventory?.field}
                  onChange={
                    (e) => {
                      setSortInventory({...sortInventory, field: e.target.value});
                    }
                  }>
                  <MenuItem value={'name'}>Name</MenuItem>
                  <MenuItem value={'waiverDate'}>Date</MenuItem>
                </Select>
              </FormControl>
              <FormControl sx={{
                width: 'auto'
              }}>
                <Select
                  autoWidth
                  sx={{
                    padding: '5px 10px',
                    marginRight: '5px'
                  }}
                  value={sortInventory?.direction}
                  onChange={
                    (e) => {
                      setSortInventory({...sortInventory, direction: e.target.value});
                    }
                  }>
                  <MenuItem value={'asc'}>Asc</MenuItem>
                  <MenuItem value={'desc'}>Desc</MenuItem>
                </Select>
              </FormControl>
            </span>}
          </h5>
          <MDBox>
            {waivers?.length === 0 && <>
              <li
                className={'list-group-item'}>
                <center>No Waivers for {formatDate(eventDate)}</center>
              </li>
            </>}
            {waivers?.length > 0 && <>
              <ul className={'list-group'}>
                {waivers?.sort((a, b) => sortInventoryFn(a, b)) // ?.sort((a, b) => a.id - b.id)
                  .map((waiver, index) => {
                    return (
                      <li index={index} key={index}
                          className={'list-group-item'}>
                        <h6 className={'mb-1'}>
                      <span className={'pull-right px-2'}
                            onClick={(e) => {
                              refHandler('downloadWaiver' + index)
                            }}
                            ref={el => (myRefs.current['downloadWaiver' + index] = el)}>

                        <MDButton
                          variant="outlined"
                          color="secondary"
                          size="small"
                          circular
                          iconOnly
                        >
                          <Icon>more_horiz</Icon>
                        </MDButton>

                        {renderIndex && myRefs.current['downloadWaiver' + index]?.visible &&
                          <Menu open={true} anchorReference={null}
                                anchorEl={myRefs.current['downloadWaiver' + index]}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "left",
                                }}>
                            <NotificationItem onClick={(e) => {
                              viewWaiver(waiver.createUser, waiver)
                            }} icon={<Icon>launch</Icon>} title="Preview"/>

                            <NotificationItem onClick={(e) => {
                              downloadWaiver(waiver.createUser, waiver)
                            }} icon={<Icon>download</Icon>} title="Download"/>

                          </Menu>
                        }
                      </span>
                          <Link to={`/client/${waiver.createUser.guid}`}>
                            {waiver.createUser.firstName} {waiver.createUser.lastName}
                          </Link>
                        </h6>
                        {waiver.waiverName}<br/>
                        <Chip size={'small'} label={formatDateTime(waiver.waiverDate)} variant={"outlined"}/>
                      </li>
                    )
                  })
                }
              </ul>
            </>
            }
          </MDBox>
        </MDBox>
      </Card>

      {showPreview &&
        <Preview previewContent={waiverPreview?.waiverBody}
                 previewTitle={waiverPreview?.waiverName}
                 showPreview={showPreview}
                 handleClose={() => {
                   setShowPreview(false);
                 }}/>
      }

    </>
  );
}